<template>
    <!-- Start Main Banner -->
    <div class="main-banner">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="row h-100 justify-content-center align-items-center">
                        <div class="col-lg-5">
                            <div class="hero-content">
							<h1>We <vue-typed-js :strings="['Create']" :startDelay="1000" :typeSpeed="75" :showCursor="false"><div><span class="typing"></span> an idea,</div></vue-typed-js>
							<vue-typed-js :strings="['Innovate']" :startDelay="2000" :typeSpeed="75" :showCursor="false"><div><span class="typing"></span>  the norms,</div></vue-typed-js><vue-typed-js :strings="['Deliver']" :startDelay="3000" :typeSpeed="75" :showCursor="true"><div><span class="typing"></span> a masterpiece,</div></vue-typed-js></h1>
                                <p>A team of tech warriors who crave for excellence, to shoot-up your businesses and enterprises through innovation-driven services on digital space.</p>
                                <a href="/contact" class="btn btn-primary">Contact Us</a>
                            </div>
                        </div>

                        <div class="col-lg-6 offset-lg-1">
                            <div class="banner-image">
                                
                                 <img src="../../../assets/img/banner-image/man.png" class="wow fadeInDown" v-wow data-wow-delay="1s" alt="man">
                                <img src="../../../assets/img/banner-image/code.png" class="wow fadeInUp" v-wow data-wow-delay="1s" alt="code">
                                <img src="../../../assets/img/banner-image/leaf-small.png" class="wow fadeInLeft" v-wow data-wow-delay="1s" alt="carpet">
                                <img src="../../../assets/img/banner-image/base.png" class="wow zoomIn" v-wow data-wow-delay="1s" alt="bin">
                                <img src="../../../assets/img/banner-image/settings.png" class="wow bounceIn" v-wow data-wow-delay="1s" alt="book">
                                <img src="../../../assets/img/banner-image/flowerpot.png" class="wow fadeInDown" v-wow data-wow-delay="1s" alt="dekstop">
                                <img src="../../../assets/img/banner-image/chat-box.png" class="wow zoomIn" v-wow data-wow-delay="1s" alt="dot">
                                <img src="../../../assets/img/banner-image/leaf-big.png" class="wow fadeInUp" v-wow data-wow-delay="1s" alt="flower-top-big">
                                <img src="../../../assets/img/banner-image/lines-small.png" class="wow rotateIn" v-wow data-wow-delay="1s" alt="flower-top">
                                <img src="../../../assets/img/banner-image/lines-big.png" class="wow fadeInUp" v-wow data-wow-delay="1s" alt="keyboard">
                                <img src="../../../assets/img/banner-image/html.png" class="wow zoomIn" v-wow data-wow-delay="1s" alt="pen">
                                <img src="../../../assets/img/banner-image/table.png" class="wow zoomIn" v-wow data-wow-delay="1s" alt="table">
                                <img src="../../../assets/img/banner-image/reload.png" class="wow fadeInLeft" v-wow data-wow-delay="1s" alt="tea-cup">
                                <img src="../../../assets/img/banner-image/bracket.png" class="wow rollIn" v-wow data-wow-delay="1s" alt="headphone">

                                <img src="../../../assets/img/banner-image/main-pic.png" class="wow fadeInUp" v-wow data-wow-delay="1s" alt="main-pic">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="shape1"><img src="../../../assets/img/shape1.png" alt="shape"></div>
        <div class="shape2 rotateme"><img src="../../../assets/img/shape2.svg" alt="shape"></div>
        <div class="shape3"><img src="../../../assets/img/shape3.svg" alt="shape"></div>
        <div class="shape4"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
        <div class="shape5"><img src="../../../assets/img/shape5.png" alt="shape"></div>
        <div class="shape6 rotateme"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
        <div class="shape7"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
        <div class="shape8 rotateme"><img src="../../../assets/img/shape2.svg" alt="shape"></div>
    </div>
    <!-- End Main Banner -->
</template>

<script>
export default {
    name: 'Banner'
}
</script>
